module.exports = __webpack_public_path__ + "img/wetrusty-logo-2.c0b18b99.png";